import { NgModule } from "@angular/core";

import { RaskCommonModule } from "~app/common/rask-common.module";
import { CertifikatEditDialogComponent } from "./certifikat-edit-dialog/certifikat-edit-dialog.component";
import { CertifikatListaKontraktDialogComponent } from "./certifikat-lista-kontrakt-dialog/certifikat-lista-kontrakt-dialog.component";
import { CertifikatComponent } from "./certifikat.component";

@NgModule({
    imports: [
        RaskCommonModule,
        CertifikatComponent,
        CertifikatEditDialogComponent,
        CertifikatListaKontraktDialogComponent
    ],
    exports: [],
    providers: []
})
export class CertifikatModule { }
